import React from 'react';
import { withStyles } from '@material-ui/core';
import styles from './pageFooter.styles';
import { PAGE_HEADER_HEIGHT } from '../pageHeader';

type PropType = {
  classes: Object,
  height: number,
  width: number,
  zoom: number,
  totalPages: number,
  pageNumber: number,
  formName: string,
  pageIndex: number,
}

const PageBorderC = ({
  classes, height, width, zoom, totalPages, pageNumber, formName, pageIndex,
}: PropType) => (
  <div
    className={classes.pageFooter}
    style={{ width: width * zoom, top: height * zoom + (pageIndex === 0 ? PAGE_HEADER_HEIGHT : 0) }}
  >
    <div style={{ textAlign: 'left', paddingLeft: '10px' }}>
      {formName}
      <div style={{ float: 'right', paddingRight: '10px' }}>
        {`${pageNumber}/${totalPages}`}
      </div>
    </div>
  </div>
);

export default withStyles(styles)(PageBorderC);
